import React from 'react';
import { Result } from 'antd';
// import { useNavigate } from 'react-router-dom';

const ResetPasswordSuccess = () => {
  //   const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Result
        status='success'
        title='Password updated successfully.'
        subTitle='Congratulation! Your password has been updated successfully!'
        // extra={[
        //   <Button
        //     type='primary'
        //     key='dashboard'
        //     onClick={() => navigate('/dashboard')}
        //   >
        //     Go to Dashboard
        //   </Button>,
        // ]}
      />
    </div>
  );
};

export default ResetPasswordSuccess;
